import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import { orange } from '@mui/material/colors';
import { Trans } from 'react-i18next';

import { environment } from '../../environment';

interface IProps {
  openOSMDialog: (open: boolean) => void;
}

function OSMCard({ openOSMDialog }: IProps): React.JSX.Element {
  return (
    <Box padding={2}>
      <Card sx={{ bgcolor: '#eee' }} variant="outlined">
        <CardContent>
          <Typography component="p" variant="caption">
            <Trans
              components={[
                <Typography
                  color="primary"
                  component="a"
                  href="https://www.openstreetmap.org"
                  key={0}
                  rel="noreferrer"
                  target="_blank"
                  variant="caption"
                />,
              ]}
              i18nKey="bicycle_facilities.stats.facilities.osm"
            />
          </Typography>
          {environment.enableTmpFacilities && (
            <Box border={`2px solid ${orange[300]}`} borderRadius={1} marginTop={1} padding={1}>
              <Typography variant="caption">
                <Trans i18nKey="bicycle_facilities.stats.facilities.osm_tmp" />
              </Typography>
            </Box>
          )}
        </CardContent>
        <CardActions sx={{ justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={() => openOSMDialog(true)} size="small" variant="outlined">
            <Trans i18nKey="commons.actions.more_informations" />
          </Button>
          <Button
            color="primary"
            component="a"
            href="https://www.openstreetmap.org/edit"
            rel="noreferrer"
            size="small"
            target="_blank"
            variant="outlined"
          >
            <Trans i18nKey="commons.actions.contribute" />
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
}

export default OSMCard;
